/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyMetadata {
    getFixupPrototypeFunction() { return PolicyMetadata.fixupPrototype; }

    static newInstance(model: Partial<PolicyMetadata>): PolicyMetadata {
        let obj = Object.assign(new PolicyMetadata(), model);
        PolicyMetadata.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyMetadata>): PolicyMetadata {
        if (!model) return null;
        return PolicyMetadata.newInstance(<PolicyMetadata> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyMetadata) {
        if (!obj) return;

        models.PolicyMetadata.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyMetadata): boolean {
        Object.setPrototypeOf(obj, PolicyMetadata.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Metadata about policy
     */
    file: string;

}
